import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UploadService } from './upload.service';
import { IFileColumn, IUploadContext, IUploadResponse } from './upload-data.service';
import { ICodeValue, IValueObject } from '../../../type_definitions/datatypes';
import * as _ from 'underscore';
import { util } from '../../shared/util';

interface IPreparedColumn {
  colId:number;
  name:string;
  oldValue:string;
  newValue:IValueObject;
}

@Component({
  selector: 'upload-validation-dialog',
  template: `
    <div class="message-dialog">
      <div class="modal-header">
        <h4 class="modal-title" translate>GA.VALIDATION.VALIDATION_FAILED</h4>
      </div>
      
      <div class="modal-body">
        <p [innerHTML]="('GA.UPLOADS.INVALID_VALUE_INFO' | translate)"></p>
        
        <table class="table table-striped col-space-top validation-table">
          <thead>
            <th style="width: 30%" translate>GA.UPLOADS.COLUMN_NAME</th>
            <th style="width: 30%" translate>GA.UPLOADS.FILE_VALUE</th>
            <th style="width: 40%" translate>GA.UPLOADS.GA_VALUE</th>
          </thead>
          
          <tbody>
            <tr *ngFor="let list of preparedColumns">
              <td>{{list.name}}</td>
              <td>{{list.oldValue}}</td>
              <td>
                <select class="form-select form-select-sm" [(ngModel)]="list.newValue" (change)="onGAValueChange(list)">
                  <option [ngValue]="undefined"></option>
                  <option *ngFor="let opt of getPossibleValues(list.colId)" [ngValue]="opt">{{opt.value}}</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>  
      </div>
      
      <div class="modal-footer footer-margin">
        <button class="btn btn-success" (click)="onDialogClose.emit()" translate>GA.BUTTONS.SAVE</button>
      </div>
    </div>
  `
})
export class UploadValidationDialogComponent implements OnInit {
  @Input() public results:IUploadResponse;
  @Output() public onDialogClose:EventEmitter<void> = new EventEmitter();

  public preparedColumns:IPreparedColumn[] = [];
  private uploadContext:IUploadContext;

  constructor(
    private uploadService:UploadService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.uploadContext = util.deepClone(this.uploadService.model.backupUploadContext);

    // prepare columns
    this.prepareColumns();
  }

  private prepareColumns():void {
    _.each(this.results.columns, (column:IFileColumn) => {
      _.each(column.valueMappings, (mapping:ICodeValue) => {
        if (_.isUndefined(mapping.code)) {
          const colContext:IFileColumn = _.findWhere(this.uploadService.model.uploadContext.columns, { colId: column.colId });

          this.preparedColumns.push({
            colId: colContext.colId,
            name: colContext.name,
            oldValue: mapping.value,
            newValue: undefined
          });
        }
      });
    });
  }

  public getPossibleValues(colId:number):IValueObject[] {
    return _.findWhere(this.uploadContext.columns, { colId })?.possibleValues;
  }

  public onGAValueChange(changedColumn:IPreparedColumn):void {
    // do nothing when user select nothing
    if (util.isNullOrUndefinedOrEmpty(changedColumn.newValue)) {
      return;
    }

    // get 'valueMappings' from results and update value mappings (response when upload failed) because uploadService.model.uploadContext doesn't have valueMappings at initial state
    const updatedColumn:IFileColumn = _.find(this.results.columns, (col:IFileColumn) => col.colId === changedColumn.colId);
    const updatedValueMappings:ICodeValue[] = _.map(updatedColumn.valueMappings, (valueMapping:ICodeValue) => {
      if (valueMapping.value === changedColumn.oldValue) {
        valueMapping.code = <string>changedColumn.newValue?.id;
      }

      return valueMapping;
    });

    // copy uploadContext and update target column 'valueMappings' object with corrected ones
    // this context will be used as request body when sending to server
    const uploadContext:IUploadContext = util.deepClone(this.uploadService.model.uploadContext);
    const targetColumn = _.find(uploadContext.columns, (col:IFileColumn) => col.colId === changedColumn.colId);
    targetColumn.valueMappings = updatedValueMappings;

    // update latest upload model
    this.uploadService.model = _.extend(this.uploadService.model, { uploadContext });
  }
}